export interface ConfigCustomerCard {
    bffBaseUrl: string;
    /** Identifies the host app for NR instrumentation (e.g. 'MV', 'SCI'). */
    hostApp?: 'MV' | 'SCI';
    /**
     * Which of the two mutually-exclusive card implementations the host resolved to for this
     * session, for NR instrumentation. SCI only ever renders 'activities'; MV picks one of the two
     * based on isActivitiesCustomerCardEnabled (see EditCustomerSlideout).
     */
    customerCardVariant?: 'activities' | 'unified';
}

let customerCardConfig: ConfigCustomerCard | undefined;

export const configureCustomerCard = (config: ConfigCustomerCard): ConfigCustomerCard => {
    customerCardConfig = config;
    return customerCardConfig;
};

export const getCustomerCardBffBaseUrl = (): string | undefined => {
    return customerCardConfig?.bffBaseUrl;
};

export const getCustomerCardConfig = (): ConfigCustomerCard | undefined => {
    return customerCardConfig;
};

/**
 * Patches customerCardVariant onto the existing config. Split out from configureCustomerCard because
 * MV only knows the variant once its feature toggles are safely readable (post-bootstrap), later than
 * the bffBaseUrl/hostApp set at bootstrap — see EditCustomerSlideout.
 */
export const setCustomerCardVariant = (customerCardVariant: ConfigCustomerCard['customerCardVariant']): void => {
    if (!customerCardConfig) return;
    customerCardConfig = { ...customerCardConfig, customerCardVariant };
};
